import { BaseUniDriver } from '@wix/wix-ui-test-utils/unidriver';

export interface StackedBarChartUniDriver extends BaseUniDriver {
  getDataLength: () => Promise<number>;
  getTooltipContentAt(index: number): Promise<any>;
}
